import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import FilterRadioButton from '../../../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../../../components/FilterRadioButtonsContainer';
import FormGroup from '../../../../../components/FormGroup';
import Input from '../../../../../components/Input';
import { GetErrorMessageByFieldNameType } from '../../../../../hooks/useErrors';
import { AsideContainer, Group, Container as StyledContainer } from '../styles';

interface BillingAddressInterface {
  getErrorMessageByFieldName: GetErrorMessageByFieldNameType;
  billingAddress: string;
  setBillingAddres: Dispatch<SetStateAction<string>>;
  isGettingBillingCepData: boolean;
  billingCep: string;
  handleBillingCepChange: (event: ChangeEvent<HTMLInputElement>) => void;
  billingUf: string;
  billingCity: string;
  billingDistrict: string;
  billingStreet: string;
  handleBillingNumberChange: (event: ChangeEvent<HTMLInputElement>) => void;
  billingNumber: string | number;
  handleBillingComplementChange: (event: ChangeEvent<HTMLInputElement>) => void;
  billingComplement: string;
}

export default function BillingAddress({
  billingAddress,
  setBillingAddres,
  getErrorMessageByFieldName,
  isGettingBillingCepData,
  billingCep,
  handleBillingCepChange,
  billingUf,
  billingCity,
  billingDistrict,
  billingStreet,
  handleBillingNumberChange,
  billingNumber,
  handleBillingComplementChange,
  billingComplement,
}: BillingAddressInterface) {
  return (
    <>
      <StyledContainer>
        <div className="card-title">
        Endereço de Faturamento
        </div>

        <Group>
          <FilterRadioButtonsContainer>
            <FilterRadioButton
              selected={billingAddress === 'same'}
              onClick={() => setBillingAddres('same')}
            >
                    Mesmo da empresa
            </FilterRadioButton>
            <FilterRadioButton
              selected={billingAddress === 'another'}
              onClick={() => setBillingAddres('another')}
            >
                    Outro
            </FilterRadioButton>
          </FilterRadioButtonsContainer>
        </Group>

        {billingAddress === 'another' && (
          <>
            <AsideContainer>
              <Group>
                <div className="title">CEP</div>

                <FormGroup error={getErrorMessageByFieldName('billingCep')} isLoading={isGettingBillingCepData}>
                  <Input
                    disabled={isGettingBillingCepData}
                    placeholder="Informe o CEP"
                    value={billingCep}
                    onChange={handleBillingCepChange}
                    autoComplete="new-password"
                    maxLength={9}
                    error={getErrorMessageByFieldName('billingCep')}
                  />
                </FormGroup>
              </Group>

              <Group>
                <div className="title">UF</div>

                <FormGroup isLoading={isGettingBillingCepData}>
                  <Input
                    disabled
                    placeholder="Preenchido automaticamente"
                    value={billingUf}
                    autoComplete="new-password"
                  />
                </FormGroup>
              </Group>
            </AsideContainer>

            <AsideContainer>
              <Group>
                <div className="title">Cidade</div>
                <FormGroup isLoading={isGettingBillingCepData}>
                  <Input
                    disabled
                    placeholder="Preenchido automaticamente"
                    value={billingCity}
                    autoComplete="new-password"
                  />
                </FormGroup>
              </Group>

              <Group>
                <div className="title">Bairro</div>
                <FormGroup isLoading={isGettingBillingCepData}>
                  <Input
                    disabled
                    placeholder="Preenchido automaticamente"
                    value={billingDistrict}
                    autoComplete="new-password"
                  />
                </FormGroup>
              </Group>

              <Group>
                <div className="title">Logradouro</div>
                <FormGroup isLoading={isGettingBillingCepData}>
                  <Input
                    disabled
                    placeholder="Preenchido automaticamente"
                    value={billingStreet}
                    autoComplete="new-password"
                  />
                </FormGroup>
              </Group>
            </AsideContainer>

            <AsideContainer>
              <Group>
                <div className="title">Número</div>
                <FormGroup error={getErrorMessageByFieldName('billingNumber')}>
                  <Input
                    onChange={handleBillingNumberChange}
                    placeholder="Caso não tenha, preencha 0"
                    value={billingNumber}
                    autoComplete="new-password"
                    error={getErrorMessageByFieldName('billingNumber')}
                  />
                </FormGroup>
              </Group>

              <Group>
                <div className="title">Complemento</div>
                <FormGroup>
                  <Input
                    onChange={handleBillingComplementChange}
                    placeholder="Complemento"
                    value={billingComplement}
                    maxLength={20}
                    autoComplete="new-password"
                  />
                </FormGroup>
              </Group>
            </AsideContainer>
          </>
        )}
      </StyledContainer>
    </>
  );
}
